import { BookInfProvider } from "components/context/bookInfContext";
import HomeWeb from "./web";
import HomeMb from "./mb";

export default function HomeView() {
  return (
    <>
      <BookInfProvider>
        <HomeWeb />
        <HomeMb />
      </BookInfProvider>
    </>
  );
}
